<ix-modal-header>
  @if (activeModal.data.passport?.metadata?.masterChildFlag === MasterChildStringEnum.MASTER) {
    {{ 'battery_pass.list.removing_master_modal_headline' | translate }}
  } @else {
    {{ 'battery_pass.list.removing_child_modal_headline' | translate }}
  }
</ix-modal-header>
<ix-modal-content>
  @if (activeModal.data.passport?.metadata?.masterChildFlag === MasterChildStringEnum.MASTER) {
    {{ 'battery_pass.list.removing_master_modal_content' | translate: {id: activeModal.data.name} }}
  } @else {
    {{ 'battery_pass.list.removing_child_modal_content' | translate: {id: activeModal.data.name} }}
  }
</ix-modal-content>
<ix-modal-footer>
  <ix-button
    (click)="activeModal.dismiss('dismiss')"
    class="close-modal"
    onkeypress=""
    variant="secondary">
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    (click)="activeModal.close(true)"
    class="dismiss-modal"
    onkeypress=""
    variant="danger-primary">
    {{ 'battery_pass.list.remove_confirm_button' | translate }}
  </ix-button>
</ix-modal-footer>
